export const colorList = [
  "#ff7eb9",
  "#7874F2",
  "#0AA1DD",
  "#fff740",
  "#FFD36E",
  "#FFF56D",
  "#99FFCD",
  "#017fe6",
];
